// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/entityView/EntityAuditTrail.scss
// module id = 1992
// module chunks = 0